import { render, staticRenderFns } from "./VuesticPageNotFoundSimple.vue?vue&type=template&id=4848a026"
import script from "./VuesticPageNotFoundSimple.vue?vue&type=script&lang=js"
export * from "./VuesticPageNotFoundSimple.vue?vue&type=script&lang=js"
import style0 from "./VuesticPageNotFoundSimple.vue?vue&type=style&index=0&id=4848a026&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4848a026')) {
      api.createRecord('4848a026', component.options)
    } else {
      api.reload('4848a026', component.options)
    }
    module.hot.accept("./VuesticPageNotFoundSimple.vue?vue&type=template&id=4848a026", function () {
      api.rerender('4848a026', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/404-pages/VuesticPageNotFoundSimple.vue"
export default component.exports